import { DataModules, IDataState } from "@/store/modules/data/index";
import { ActionTree, GetterTree } from "vuex";
import { Methods } from "@/models/methods";
import { IState } from "@/store";
import { ApiPathGetter } from "@/models/api";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (
    s,
    g,
    rS,
    { isAdminContext, isMockClientContext }
  ): ApiPathGetter => (slug = "payments") => {
    const admin = `api/admin/${slug}`;
    const client = `api/${slug}`;
    const contextual =
      isAdminContext && !isMockClientContext() ? admin : client;
    return { client, admin, contextual };
  },
  scope: () => id => {
    return `$payment${id}`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath("payment_logs").admin,
        storeModule: DataModules.PAYMENTS
      },
      { root: true }
    );
  },
  create: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/create",
      {
        ...payload,
        path: getters.apiPath().contextual,
        storeModule: DataModules.PAYMENTS
      },
      { root: true }
    );
  },
  manualPayment: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/callApi",
      {
        ...payload,
        method: Methods.POST,
        path: `${getters.apiPath().admin}/manual`,
        requestConfig: { data: payload.data },
        storeModule: DataModules.PAYMENTS
      },
      { root: true }
    );
  },
  refundTransactions: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/callApi",
      {
        ...payload,
        method: Methods.POST,
        path: `${getters.apiPath().admin}/refund_transactions`,
        requestConfig: { data: payload.data },
        storeModule: DataModules.PAYMENTS
      },
      { root: true }
    );
  },
  openTransactionModal: ({ dispatch }, payload) => {
    dispatch(
      "ui/open/slideModal",
      {
        config: {
          component: () =>
            import("@/components/app/admin/transactions/transactionModal.vue"),
          ...payload
        }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
